
            const data = {"name":"solid/square","data":{"viewBox":"0 0 448 512","data":"<path pid=\"0\" d=\"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z\"/>","originalColors":[],"stopColors":[]}}
        
                    module.exports = data
                    